import { render, staticRenderFns } from "./UbaNotification.vue?vue&type=template&id=781d34d6&scoped=true"
import script from "./UbaNotification.vue?vue&type=script&lang=js"
export * from "./UbaNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781d34d6",
  null
  
)

export default component.exports